import { useEffect, useState } from 'react';

import emailSpellChecker from '@zootools/email-spell-checker';
import type { MailSuggestion } from '@zootools/email-spell-checker/dist/lib/types';

export function useMailcheck(email?: string) {
  const [suggestion, setSuggestion] = useState<MailSuggestion | undefined>(undefined);
  useEffect(() => {
    try {
      setSuggestion(
        emailSpellChecker.run({
          email: email || '',
          empty: () => {
            setSuggestion(undefined);
          },
        })
      );
    } catch {
      setSuggestion(undefined);
    }
  }, [email]);

  return suggestion;
}

export default useMailcheck;
